import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getConfigurationViewQuery,
  getGradesModuleSettingQuery,
  getCourseModuleSettingQuery,
  getCurriculumCustomCoursesQuery,
  getNotificationConfigurationViewQuery,
  getPermissionsQuery,
} from "./ConfigurationQuery";

export const getConfigurationViewFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getConfigurationViewQuery,
      variables,
    });

    return _.get(result, "platform.configurationView", []);
  } catch (error) {
    return [];
  }
};

export const getNotificationConfigurationViewFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getNotificationConfigurationViewQuery,
      variables,
    });

    return _.get(result, "platform.notificationConfigurationView", []);
  } catch (error) {
    return [];
  }
};

export const getCurriculumCustomCoursesFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getCurriculumCustomCoursesQuery,
      variables,
    });

    return _.get(result, "node", {});
  } catch (error) {
    return [];
  }
};

export const getPermissionsFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getPermissionsQuery,
      variables,
    });
    return _.get(result, "platform", {});
  } catch (error) {
    return {};
  }
};

export const getGradesModuleSettingFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getGradesModuleSettingQuery,
      variables,
    });
    return _.get(result, "node", {});
  } catch (error) {
    return {};
  }
};

export const getCourseModuleSettingFromCache = variables => {
  try {
    const result = client.readQuery(
      {
        query: getCourseModuleSettingQuery,
        variables,
      },
      true
    );
    return _.get(result, "node", {});
  } catch (error) {
    return {};
  }
};

export const writeCurriculumCustomCoursesToCache = ({ data, variables }) => {
  try {
    client.writeQuery({
      query: getCurriculumCustomCoursesQuery,
      data: { node: data },
      variables,
    });
  } catch (error) {
    console.error(error);
    return false;
  }
  return true;
};

export const writeCourseModuleSettingToCache = ({ data, variables }) => {
  try {
    client.writeQuery({
      query: getCourseModuleSettingQuery,
      data,
      variables,
    });
  } catch (error) {
    console.error(error);
    return false;
  }
  return true;
};

export const writePermissionsToCache = ({ data, variables }) => {
  try {
    client.writeQuery({
      query: getPermissionsQuery,
      data,
      variables,
    });
  } catch (error) {
    console.error(error);
    return false;
  }
  return true;
};
